import { useLocation } from 'react-router-dom';
import { useStoreActions, useStoreState } from '~/store';

const CHAT_PATH = '/notifications/chat';

export const useNotificationContext = (overrideIsChat?: boolean) => {
  const location = useLocation();
  const isChatFromLocation = location.pathname.startsWith(CHAT_PATH);
  const isChatFromWindow = window.location.pathname.includes(CHAT_PATH) || window.location.hash.includes(CHAT_PATH);
  const isChat = overrideIsChat !== undefined
    ? overrideIsChat
    : (isChatFromLocation || isChatFromWindow);

  const useNotificationState = (selector: (slice: any) => any) =>
    useStoreState(state =>
      isChat ? selector(state.chat) : selector(state.notification)
    );

  const useNotificationAction = (selector: (slice: any) => any) =>
    useStoreActions(actions =>
      isChat ? selector(actions.chat) : selector(actions.notification)
    );

  return { isChat, isNotifications: !isChat, useNotificationState, useNotificationAction };
};
